export default {
  api: document.location.protocol
    + '//' + document.location.host.replace('admin.', 'api.') + '/admin/v1/',
};
